"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var palette = {
  background: {
    primary: {
      color: '#FFFFFF',
      contrast: '#000000'
    },
    secondary: {
      color: '#ECEFF1',
      contrast: '#000000'
    }
  },
  accent: {
    primary: {
      color: '#303F9F',
      contrast: {
        high: '#000000',
        low: '#FFFFFF'
      }
    },
    secondary: {
      color: '#00796B',
      contrast: {
        high: '#000000',
        low: '#FFFFFF'
      }
    }
  }
};
var _default = palette;
exports["default"] = _default;